<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 * 
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *            佛祖保佑       永不宕机     永无BUG
 * 
 *        佛曰:  
 *                写字楼里写字间，写字间里程序员；  
 *                程序人员写程序，又拿程序换酒钱。  
 *                酒醒只在网上坐，酒醉还来网下眠；  
 *                酒醉酒醒日复日，网上网下年复年。  
 *                但愿老死电脑间，不愿鞠躬老板前；  
 *                奔驰宝马贵者趣，公交自行程序员。  
 *                别人笑我忒疯癫，我笑自己命太贱；  
 *                不见满街漂亮妹，哪个归得程序员？
 * 
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-07-14 17:30:53
 * @LastEditTime: 2021-10-26 16:39:35
 * @FilePath: \uniapp-npm\lushh-comment-vue\src\components\commentsCell.vue
 * @Description: 
 -->

<template>
  <div class="comment">
    <div class="comment-main" :class="{ 'comment-mainObj': allComment }">
      <div class="comment-info">
        <img
          :src="userIconFix(AppCommentVO)"
          mode="aspectFit"
          class="comment-info-icon"
        />
        <p class="comment-info-nickName">
          {{ AppCommentVO.commentUserNickname }}
        </p>
      </div>
      <div class="comment-marginLeft">
        <p class="comment-content">{{ AppCommentVO.content }}</p>
        <div class="comment-desc">
          <div class="comment-desc-left">
            <p class="comment-desc-left-p">{{ AppCommentVO.createTime }}</p>
            <p class="comment-desc-left-p comment-desc-left-character">·</p>
            <p
              class="comment-desc-left-p comment-desc-left-bold"
              @click="
                replay(
                  AppCommentVO.commentId,
                  AppCommentVO.commentId,
                  AppCommentVO.commentUserId
                )
              "
            >
              回复
            </p>
          </div>
          <div class="comment-desc-likes" @click="likeOrDislike(AppCommentVO)">
            <img
              class="comment-desc-likes-icon"
              :src="AppCommentVO.likesFlag ? likeIcon : dislikeIcon"
            />
            <p class="comment-desc-likes-nums">{{ AppCommentVO.likesNum }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="comment-sub-content" v-if="subFlag">
      <div
        class="comment-main"
        v-for="(children, index) in AppCommentVO.children"
        :key="index"
      >
        <div class="comment-info">
          <img
            :src="userIconFix(children)"
            mode="aspectFit"
            class="comment-info-icon"
          />
          <p class="comment-info-nickName">
            {{ children.commentUserNickname }}
          </p>
        </div>
        <div class="comment-marginLeft">
          <div v-if="children.replyToUserId">
            <span>回复</span
            ><span style="color: #2884fd">@${children.replyToUserNickname}</span
            ><span>：${children.content}</span>
          </div>
          <p class="comment-content" v-else>{{ children.content }}</p>
          <div class="comment-desc">
            <div class="comment-desc-left">
              <p class="comment-desc-left-p">{{ children.createTime }}</p>
              <p class="comment-desc-left-p comment-desc-left-character">·</p>
              <p
                class="comment-desc-left-p comment-desc-left-bold"
                @click="
                  replay(
                    AppCommentVO.commentId,
                    children.commentId,
                    children.commentUserId
                  )
                "
              >
                回复
              </p>
            </div>
            <div class="comment-desc-likes" @click="likeOrDislike(children)">
              <img
                class="comment-desc-likes-icon"
                :src="children.likesFlag ? likeIcon : dislikeIcon"
              />
              <p class="comment-desc-likes-nums">{{ children.likesNum }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="AppCommentVO.replyNum > 2 && !subComment"
        class="comment-sub-more"
        @click="viewAll(AppCommentVO)"
      >
        <p class="comment-sub-more-p">
          查看全部{{ AppCommentVO.replyNum }}条回复&gt;
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appFusionId: {
      type: String,
      default: ''
    },
    allComment: {
      type: Boolean,
      default: false
    },
    mainCommentObj: {
      type: Object,
      default: () => {}
    },
    token: {
      type: String,
      default: ''
    },
    AppCommentVO: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      AppCommentRes: {
        children: []
      },
      containerStyle: 'font-size: 28px;color:#444444;line-height:42px;',
      dislikeIcon:
        'data:image/png;base64,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',
      likeIcon:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAEpUlEQVRoge1ZTWgdVRg9587kxaSmXVhFrLbophpdqQXBKopCV9UuitZV3cSNCOLCguDGjVuhC5UUN2Yh9QfqxlJxUVyIiooEFLIpFbEKtv42MS9vviP3ziR5mZk3701eEh3IgfvmcWfm3u/c73fuxTa2sY1KMH8zfv4clBikDhQJzlqgJYBzkHMDr6Zg/uc5CkfTaewT0U6Krd/UWQTsL4BRxQACXATGE3ACRAMVAUpg7R+hN6fWyr1ZeqZwBsBj6VLJ9zzo6J5NxMMAvkj7VDFCv/trMRgRMl0hs/Ra0GPh+WcCibxo4g0O+NyoSdB9D1ZpWBAGt4AaGnGgtZHY1ZRYz/kFxtceJ1venEoe6MC5+Kywa1/Veocp0p8e46xFDSIWbNaN7ASsr0p2Vk4u7dXI2JRGxqahXs8RWpoHk6X+FlDfRxg0U2VdwRuoiephHJy1X9ZiezoMVjIPydRLgvn118jgRrgiqYL1Wo8maDeAm/uPY7fANCkR+Zb6Y1LOccOIpOsF+Mjpo2G8tjHCwfRO/1FAd7df+V6tDtYffv3KQYjCqqk7JT016BBEsrdb3FUFsEbgTbFuIgxm5M03C5L0oZm7jXyixihxXYF7YeiEmGSaMCefBE+zjmTS76mJDSvFOn2kG8syOHOvU3y4zrtifEnoQLYwtCgbUaJcD+BUWSbvC+dmTYLrJEML0ZsI3QsED4PaoeWCiT6J4G8S7wl4l8AxEq8A2LWeyWntGYfoD0bj3sHaAHxbzK4LhP4E4NtsWp/hp8GJpNnuLBEdwnJEKtiwHqLwKoDqxNefyj0MJlVehnTHLoptgK8BOFH2bAkRvATgUBZSfwXwbe6J2wDcOjyJ1QkHrHJboF4EsA+MjuVvFogYdCRTwC8CJglcWbkZkq5IcRbEnUMyqA9fl5FPMt5zWsAH3e8XQgWFGGmum3NmV9hdJ6TFj//9estJdAlBjhzP95bFvKXs2srew0puWHYXYnwTJa1GkCUp1HJVwXvVxb1W1OPeliMrKmsQ+X9CQepC4mkeEQ/Hy4Wu/0aSIZCmnEJibBwRH0UV82K+v3FE5D/CEruQ72+kj0j4Id/XSCIRMZfva6KzzxndpXz3pm2ZbhrEb6wkITaLiE/qib70+wR5NMu0Qt2XfORY/KJskEZCbXIBrdHvyu42yrREnOm1edoMIkEZBEaimeXP37yXNIOIJ5F0LurqP1+F/yVoBhH/ZWetaZfEK6rIu3sVkVVzLG4o99/n30iYYIzewI5rem5UlBBRK43KplCg5V7N+tp1zveGB9+hW7hMzq+MlNdISR6JlsKCE3eZi+6TP6aCXHZU4EDsB/DAFrLwpnWCXgzGqy2HQo8c3qZwAOCEU/IZ6D9i/FZ7qhxK3R/+74fzYvARANdtCgfwLZorVLt9fcSQnIxSwR7Pum7qMcfHkh0NOpWNAzxA4H6ABwHem+0Jr4UG3bZIHxLsU5OmBtnhL+rIO7bhCMinQTwK6cbcHFdkOgfhVBoEwizzgM4LOu/7aByVRbfTYT+c7vDnJpD2yPmzRY45w6jKA4YDuQAkP0P6EIxmwoFerbOKbWxjGwUA+BfeR7f7f8JoawAAAABJRU5ErkJggg==',
      defaultUserIcon:
        'data:image/png;base64,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'
    }
  },
  computed: {
    subFlag: function () {
      if (this.AppCommentVO?.children ?? false) {
        return true
      } else {
        return false
      }
    },
    subComment: function () {
      return this.mainCommentObj ? true : false
    }
  },
  mounted() {},
  methods: {
    viewAll(mainCommentObj) {
      this.$emit('viewAll', mainCommentObj)
    },
    likeOrDislike(commentObj) {
      if (this.token ?? false) {
        if (commentObj.likesFlag) {
          this.cancel(commentObj)
        } else {
          this.operation(commentObj)
        }
      } else {
        this.$emit('getToken')
      }
    },
    cancel(commentObj) {
      let serviceLogic = (res) => {
        console.log('业务逻辑处理:')
        console.log(res)
        if (res.data?.success ?? false) {
          commentObj.likesNum--
          commentObj.likesFlag = false
        }
      }
      this.$api.saasComment.cancel
        .request({
          data: {
            objectId: commentObj.commentId,
            objectType: 'PL',
            operationType: 'DZ',
            applicationId: this.appFusionId
          },
          header: {
            Authorization: this.token
          }
        })
        .then((res) => {
          serviceLogic(res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    operation(commentObj) {
      let serviceLogic = (res) => {
        console.log('业务逻辑处理:')
        console.log(res)
        if (res.data?.success ?? false) {
          commentObj.likesNum++
          commentObj.likesFlag = true
        }
      }
      this.$api.saasComment.operation
        .request({
          data: {
            objectId: commentObj.commentId,
            objectType: 'PL',
            operationType: 'DZ',
            applicationId: this.appFusionId
          },
          header: {
            Authorization: this.token
          }
        })
        .then((res) => {
          serviceLogic(res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    userIconFix(userInfo) {
      if (userInfo?.commentUserIcon ?? false) {
        return userInfo.commentUserIcon
      } else {
        return this.defaultUserIcon
      }
    },
    replay(parentCommentId, replyToComment, replyToUserId) {
      console.log('replay')
      this.$emit('update:inputShow', true)
      if (this.subComment && this.allComment) {
        this.$emit('update:parentCommentId', this.mainCommentObj.commentId)
      } else {
        if (parentCommentId ?? false) {
          this.$emit('update:parentCommentId', parentCommentId)
        }
        if (replyToComment ?? false) {
          this.$emit('update:replyToComment', replyToComment)
        }
        if (replyToUserId ?? false) {
          this.$emit('update:replyToUserId', replyToUserId)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$info-icon-width: 25px;
$info-icon-height: 25px;
$info-icon-marginRight: 10px;
$comment-sub-content-marginLeft: $info-icon-width + $info-icon-marginRight;
.comment {
  border-bottom: 1px solid #c4c4c4;
  padding-bottom: 18px;
  &-main {
    padding-top: 18px;
    display: flex;
    flex-direction: column;
  }
  &-mainObj {
    padding-left: ($info-icon-width + $info-icon-marginRight);
  }
  &-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    &-icon {
      width: $info-icon-width;
      height: $info-icon-height;
      margin-right: $info-icon-marginRight;
      border-radius: 50%;
    }
    &-nickName {
      font-size: 13px;
      color: #666666;
      font-weight: 600;
    }
  }
  &-marginLeft {
    margin-left: ($info-icon-width + $info-icon-marginRight);
    display: flex;
    flex-direction: column;
  }
  &-content {
    display: flex;
    flex-direction: row;
    font-size: 13px;
    color: #444444;
    line-height: 21px;
  }
  &-desc {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    &-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      &-p {
        font-size: 13px;
        color: #666666;
      }
      &-character {
        margin: 0 8px;
      }
      &-bold {
        font-weight: 600;
      }
    }
    &-likes {
      display: flex;
      flex-direction: row;
      align-items: center;
      &-icon {
        width: 15px;
        height: 15px;
      }
      &-nums {
        margin-left: 5px;
        font-size: 11px;
        color: #666666;
      }
    }
  }
  &-sub-content {
    margin-left: $comment-sub-content-marginLeft;
  }
  &-sub-more {
    margin-top: 12px;
    background: #f7f7f7;
    padding: 0 6px;
    line-height: 21px;
  }
  &-sub-more-p {
    color: #036eb8;
  }
}
</style>
